<template>
  <div class="common-leaving-dialog">
    <van-popup v-model="show" style="border-radius: .22rem;">
      <img style="width: 5.8rem; height: 7.2rem;" v-if="img" :src="img" @click="onConfirm">
      <button @click="onCancel">{{ cancelText }}</button>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'leaveDialog',
  props: {
    value: Boolean,
    img: {
      type: String,
      required: true
    },
    cancelText: {
      type: String,
      default: '放弃'
    }
  },
  data () {
    return {
      show: false
    }
  },
  watch: {
    value (v) {
      if (v) {
        this.show = true
      }
    },
    show (v) {
      if (!v) {
        this.$emit('input', false)
      }
    }
  },
  methods: {
    onConfirm () {
      this.show = false
      this.$emit('confirm')
    },
    onCancel () {
      this.show = false
      this.$emit('cancel')
    }
  }
}

</script>

<style scoped lang="less">
.common-leaving-dialog {
  button {
    position: absolute;
    text-align: center;
    width: 100%;
    height: .8rem;
    line-height: .8rem;
    bottom: 0;
    color: #adadad;
  }
}
</style>
